import React from 'react'
import { connect } from 'react-redux'
import { Grid, Container, List, ListItem, Card, CardContent, Chip, IconButton, Typography, Button } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { addAddress, removeAddress } from '../../actions/userAction'
import AddNewAddress from './AddNewAddress'


const useStyles = makeStyles((theme) => ({
    addressPage: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minHeight: '50vh'
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    card: {
        borderRadius: '20px',
    },
    text: {
        [theme.breakpoints.only('xs')]: {
            textAlign: 'center'
        }
    },
    addButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.only('xs')]: {
            justifyContent: 'center',
            marginTop: theme.spacing(1)
        }
    }

}));


const AddressBook = (props) => {
    const classes = useStyles()
    const [isAddressOpen, addressToggle] = React.useState(false)

    const { addresses } = props
    const len = addresses.length

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function onDelete(address) {
        if (window.confirm('Are you sure you want to remove this Addresss?')) {
            props.removeAddress(address)
        }
    }

    function onAdd(address) {
        console.log(address);
        addressToggle(false)
        props.addAddress(address)

    }

    function renderSingleAddress(address) {
        return (
            <Grid item xs={12} sm={6} md={6} key={address.id} id={address.id}>
                <Card variant="outlined" className={classes.card}>
                    <CardContent>
                        <Typography>
                            {address.doorNumber} {', '} {address.landmark}
                        </Typography>
                        <Typography color="textSecondary">
                            {address.address}
                        </Typography>
                        <Typography>{address.phoneNumber}</Typography>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "0", padding: "0" }}>
                            <Chip label={address.label} color="secondary" />
                            <IconButton edge="end" aria-label="delete" onClick={() => onDelete(address)} >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        )

    }



    return (
        <Container className={classes.addressPage}>
            <Grid container justify="center">
                <Grid item xs={12} sm={8} >

                    <Grid container justify="center">
                        <Grid item sm={8} xs={12}>
                            <Typography color="primary" component="div" variant="h5" className={classes.text}>Your Delivery Addresses</Typography>
                        </Grid>
                        <Grid item sm={4} xs={12} className={classes.addButton} >
                            <Button
                                startIcon={<AddIcon />}
                                size="small"
                                color="primary"
                                variant="contained"
                                onClick={() => addressToggle(true)}
                            >
                                Add Address
                          </Button>
                        </Grid>
                    </Grid>

                    <AddNewAddress
                        isOpen={isAddressOpen}
                        onClose={() => addressToggle(false)}
                        handleSubmit={(data) => onAdd(data)}
                    />
                    {
                        len === 0
                            ?
                            <Typography color="textSecondary" className={classes.marginTop} align="center">
                                No Delivery Addresses
                             </Typography>
                            :

                            <Grid container spacing={2} className={classes.marginTop}>
                                {addresses.map(address => renderSingleAddress(address))}
                            </Grid>

                    }
                </Grid>
            </Grid>

        </Container>
    )

}

const mapStateToProps = (state) => {
    return {
        addresses: state.user.profile.addresses || []
    }
}

export default connect(mapStateToProps, { addAddress, removeAddress })(AddressBook)